import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  alt: string;
}
const ImageModal: React.FC<ImageModalProps> = ({
  isOpen,
  onClose,
  imageUrl,
  alt
}) => {
  const imageRef = useRef<HTMLImageElement>(null);
  const [closeButtonPosition, setCloseButtonPosition] = useState({
    top: 0,
    right: 0
  });
  useEffect(() => {
    const updateClosePosition = () => {
      if (imageRef.current) {
        const rect = imageRef.current.getBoundingClientRect();
        setCloseButtonPosition({
          top: rect.top - 48,
          right: window.innerWidth - rect.right - 12
        });
      }
    };
    if (isOpen) {
      updateClosePosition();
      window.addEventListener('resize', updateClosePosition);
    }
    return () => window.removeEventListener('resize', updateClosePosition);
  }, [isOpen]);
  return <AnimatePresence data-id="element-109">
      {isOpen && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-110">
          <motion.div className="fixed inset-0 bg-black/60 backdrop-blur-sm" data-id="element-111" />
          <motion.div className="relative z-10 flex items-center justify-center w-full h-full" data-id="element-112">
            <motion.button onClick={onClose} className="fixed p-2 rounded-full bg-white/90 hover:bg-white shadow-lg transition-colors duration-200" style={{
          top: `${Math.max(closeButtonPosition.top, 16)}px`,
          right: `${Math.max(closeButtonPosition.right, 16)}px`,
          zIndex: 60
        }} whileHover={{
          scale: 1.1
        }} whileTap={{
          scale: 0.9
        }} data-id="element-113">
              <XIcon className="w-6 h-6 text-gray-800" data-id="element-114" />
            </motion.button>
            <motion.img ref={imageRef} src={imageUrl} alt={alt} className="w-auto h-auto max-w-full max-h-[85vh] object-contain rounded-xl shadow-2xl" initial={{
          scale: 1.02,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.2
        }} draggable={false} data-id="element-115" />
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
};
export default ImageModal;